/**
 * 字符串转base64
 */
export function encode(str) {
	// 对字符串进行编码
	var encode = encodeURI(str);
	// 对编码的字符串转化base64
	var base64 = btoa(encode);
	return base64;
}
/**
 * base64转字符串
 */
export function decode(base64) {
  // 对base64进行解码
  var decode = atob(base64);
  // 对解码的字符串进行解码
  var decodeStr = decodeURI(decode);
  return decodeStr;
}


// WEBPACK FOOTER //
// ./src/utils/utils.js